// extracted by mini-css-extract-plugin
export default {"wrapper":"confirmation_wrapper__W6eIo","controls":"confirmation_controls__AowaI","opacity-transition":"confirmation_opacity-transition__oJyRX"};